import React, { useState } from "react";
import {
  Upload,
  List,
  message,
  Typography,
  Layout,
  Button,
  Empty,
  Spin,
} from "antd";
import {
  UploadOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import usePersonnelInfoService from "../../../../services/usePersonnelInfoService";

const { Title } = Typography;
const { Content } = Layout;

export default function PersonnelCVPage({ cvUrl }) {
  const [cvList, setCVList] = useState(
    cvUrl ? [{ name: "Uploaded CV", url: cvUrl }] : []
  );
  const [selectedFile, setSelectedFile] = useState(null);
  const [isCVUploaded, setIsCVUploaded] = useState(Boolean(cvUrl));

  const { useUploadCv, useDeleteCv } = usePersonnelInfoService();
  const { mutateAsync: uploadCvMutation, isPending: isCvUploadLoading } =
    useUploadCv();
  const { mutateAsync: deleteCvMutation, isPending: isCvDeleteLoading } =
    useDeleteCv();

  const handleFileSelect = (info) => {
    if (info.fileList.length > 0) {
      setSelectedFile(info.fileList[0]);
      setIsCVUploaded(false);
    } else {
      setSelectedFile(null);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      message.warning("Lütfen bir dosya seçin.");
      return;
    }

    try {
      const file = selectedFile.originFileObj || selectedFile;
      const response = await uploadCvMutation(file);
      console.log("cv upload response is ", response);
      setCVList([{ name: file.name, url: response.data.cvUrl || "#" }]);
      setIsCVUploaded(true);
      setSelectedFile(null);
    } catch (error) {
      message.error("CV yüklenemedi, lütfen tekrar deneyin.");
    }
  };

  const handleDelete = async () => {
    try {
      await deleteCvMutation();
      setCVList([]);
      setIsCVUploaded(false);
    } catch (error) {
      message.error("CV silinirken bir hata oluştu.");
    }
  };

  const uploadProps = {
    name: "file",
    accept: ".pdf,.docx",
    maxCount: 1,
    fileList: selectedFile ? [selectedFile] : [],
    beforeUpload: () => false,
    onChange: handleFileSelect,
    showUploadList: true,
  };

  return (
    <Layout style={styles.pageContainer}>
      <Content style={styles.content}>
        <div style={styles.card}>
          <Spin spinning={isCvUploadLoading || isCvDeleteLoading}>
            <Title level={3} style={styles.title}>
              CV Yükle
            </Title>

            <div style={styles.uploadSection}>
              <Upload {...uploadProps}>
                <Button
                  icon={<UploadOutlined />}
                  disabled={isCVUploaded || selectedFile}
                  style={styles.selectButton}>
                  CV Seç
                </Button>
              </Upload>

              <Button
                type="primary"
                onClick={handleUpload}
                disabled={!selectedFile || isCVUploaded}
                style={styles.uploadButton}>
                CV Yükle
              </Button>
            </div>

            {isCVUploaded && (
              <div style={styles.warning}>
                <InfoCircleOutlined style={styles.warningIcon} />
                <span>
                  Sisteme bir adet CV yükleyebilirsiniz. Yeni bir CV yüklemek
                  için mevcut CV'nizi silmeniz gerekir.
                </span>
              </div>
            )}

            <div style={styles.listContainer}>
              {cvList.length > 0 ? (
                <List
                  style={styles.list}
                  header={<div style={styles.listHeader}>Yüklenen CV</div>}
                  bordered
                  dataSource={cvList}
                  renderItem={(item) => (
                    <List.Item
                      actions={[
                        <Button
                          key="delete"
                          type="text"
                          danger
                          icon={<DeleteOutlined />}
                          onClick={handleDelete}>
                          Sil
                        </Button>,
                      ]}>
                      <List.Item.Meta
                        avatar={
                          item.name.endsWith(".pdf") ? (
                            <FilePdfOutlined style={styles.fileIcon} />
                          ) : (
                            <FileWordOutlined style={styles.fileIcon} />
                          )
                        }
                        title={<a href={item.url}>{item.name}</a>}
                      />
                    </List.Item>
                  )}
                />
              ) : (
                <Empty
                  description="Henüz CV yüklenmemiş"
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              )}
            </div>
          </Spin>
        </div>
      </Content>
    </Layout>
  );
}

const styles = {
  pageContainer: {
    minHeight: "400",
    backgroundColor: "#f0f2f5",
  },
  content: {
    padding: "24px",
    width: "80%",
    margin: "0 auto",
  },
  card: {
    backgroundColor: "white",
    padding: "24px",
    borderRadius: "8px",
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.03)",
  },
  title: {
    marginBottom: "24px",
    color: "#262626",
  },
  uploadSection: {
    marginBottom: "24px",
    display: "flex",
    gap: "12px",
    alignItems: "flex-start",
  },
  selectButton: {
    minWidth: "120px",
  },
  uploadButton: {
    minWidth: "120px",
  },
  warning: {
    backgroundColor: "#fffbe6",
    border: "1px solid #ffe58f",
    borderRadius: "4px",
    padding: "12px",
    marginBottom: "24px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  warningIcon: {
    color: "#faad14",
    fontSize: "16px",
  },
  listContainer: {
    marginTop: "24px",
  },
  list: {
    backgroundColor: "white",
    border: "1px solid #f0f0f0",
    borderRadius: "4px",
  },
  listHeader: {
    fontWeight: "500",
    color: "#262626",
  },
  fileIcon: {
    fontSize: "24px",
    color: "#1890ff",
  },
};
